import $ from 'jquery';

let isFetching = false;

/**
 * @param payload {BannerPayload}
 */
export async function fetchPrice(payload) {
    const $form = $('.banner-form .calc-price-ajax-form');
    if ($form.length === 0) {
        console.warn('No ajax form found')
        return null;
    }

    if  (!payload.placement || !payload.dateStart.date || !payload.dateEnd.date) {
        return null;
    }

    if (isFetching) {
        return null;
    }
    isFetching = true;


    $form.find('input[name$="[payload]"]').val(JSON.stringify(payload));

    let response = await fetch($form.attr('action'), {
        method: 'POST',
        body: $form.serialize(),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
    if (response.status >= 500) {
        console.warn('Error while fetching price', response.status, response.statusText);
        isFetching = false;
        return null;
    }

    let data = null;
    try {
        data = await response.json();
    } catch (e) {
        console.warn(e);
        isFetching = false;
        return null;
    }

    if (!response.ok) {
        console.warn(`[${response.status}] ${data.error}`);
        isFetching = false;
        return null;
    }

    isFetching = false;
    return data;
}
